<template>
  <div>
    <slot name="fallback">
      <ContentCard v-show="loading">
        <div class="loader-spinner" />
      </ContentCard>
    </slot>
    <div v-show="!loading" class="loader-content">
      <slot />
    </div>
  </div>
</template>

<script>
import ContentCard from '@sephora-asia/core-content-card/ContentCard.vue'
export default {
  name: 'Loader',
  components: {
    ContentCard
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loader-spinner {
  animation: spin 0.7s linear infinite;
  border-width: 7px;
  border-style: solid;
  border-color: #f1f1f1;
  border-top-color: #666;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
